/**
 * Setup locking form
 * Disables subsequent submits & disables all type=submit buttons
 *
 * usage: .js-locking-form
 */
export function setupLockingForms() {
  const lockingForms = document.querySelectorAll('.js-locking-form');

  lockingForms.forEach((form) => {
    form.postSubmit = (submittedForm) => {
      // eslint-disable-next-line no-console
      console.log('locking', submittedForm);
      // visually lock
      submittedForm.classList.add('js-form-submitting');
      document.body.classList.add('js-form-submitting');

      // lock all submit buttons
      const submits = submittedForm.querySelectorAll('[type="submit"]');
      submits.forEach((submit) => {
        submit.setAttribute('disabled', 'disabled');
      });

      // prevent subsequent submits
      form.addEventListener('submit', (e) => {
        e.preventDefault();
      });
    };

    if (form.classList.contains('js-recaptcha')) {
      // this is handled by the recaptcha
    } else {
      form.addEventListener('submit', () => {
        form.postSubmit(form);
      });
    }
  });
}

export default { setupLockingForms };
